<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.printResults}}</h3>
</div>
<div class="modal-body">
    <form class="form-signin">
        <div class="row">
            <div class="col-md-12">
                <label for="metadata">{{LOCALIZATION.metadataAll}}</label>
                <div class="toggle-switch">
                    <input id="metadata" name="metadata" class="toggle-switch-toggle toggle-switch-toggle-round" type="checkbox" [(ngModel)]="input.allMetadata">
                    <label for="metadata"></label>
                </div>
            </div>
            <div class="col-md-12"><span>
            	<em>When enabled, all available fields are printed. If disabled, only the fields that are visible in the results panel will be printed.</em>
            </span></div>
        </div>
        <br>
        <div class="row">
            <div class="col-md-12">
                <label for="format">{{LOCALIZATION.metadataFormat}}</label>
                <select id="format" name="format" class="form-control" [(ngModel)]="input.format">
                    <option value="txt">{{LOCALIZATION.txt}}</option>
                    <option value="csv">{{LOCALIZATION.csv}}</option>
                    <option value="html">{{LOCALIZATION.html}}</option>
                </select>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
    <button class="btn btn-primary" type="button" (click)="print()">{{LOCALIZATION.print}}</button>
</div>